// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlayEditor_IRF88 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
}

.overlayContent_BJQRY {
  flex: 1 1 400px !important;
  overflow: hidden;
}

.list_PbjK4 {
  overflow-y: scroll;
  height: calc(100% - 50px);
}

.listItem_xNGty {
  cursor: pointer;
}

.listItem_xNGty:active {
  background-color: var(--color-base050) !important;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/imagine/attributes/device/DeviceSelector.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iDAAiD;AACnD","sourcesContent":[".overlayEditor {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: white;\n}\n\n.overlayContent {\n  flex: 1 1 400px !important;\n  overflow: hidden;\n}\n\n.list {\n  overflow-y: scroll;\n  height: calc(100% - 50px);\n}\n\n.listItem {\n  cursor: pointer;\n}\n\n.listItem:active {\n  background-color: var(--color-base050) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlayEditor": `overlayEditor_IRF88`,
	"overlayContent": `overlayContent_BJQRY`,
	"list": `list_PbjK4`,
	"listItem": `listItem_xNGty`
};
export default ___CSS_LOADER_EXPORT___;
